import React from "react";
import './AddBusiness.scss';
import LogoSloganImage from "../../../resources/images/ShipitLogoWithSlogan.png";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import BusinessSettings from "../../Components/BusinessSettings/BusinessSettings";
import Direction from "../../Utils/Direction/Direction";

export default class AddBusiness extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            successDialogOpen: false,
            bid: undefined
        };
    }

    async handleSave(settings) {
        const response = await axios.post('/api/v2a/saveBusiness', settings);
        if (response.status === 200) {
            this.setState({
                successDialogOpen: true,
                bid: response.data
            });
        }
    }

    handleCloseDialog(bid) {
        window.open('/ship/' + bid, '_blank');

        this.setState({successDialogOpen: false});
    };

    render() {
        return (
            <Direction direction="rtl">
                <div className="settings-page">
                    <div className="logo">
                        <img src={LogoSloganImage} alt={"shipit"}/>
                    </div>
                    <div className="page-label">
                        הוספת עסק
                    </div>
                    <div className="business-settings-container">
                        <BusinessSettings withSaveButton={true} advancedSettings={true} withIdInput={true}
                                          settingsHeight="90%" onSave={this.handleSave.bind(this)}
                        />
                    </div>

                    <Dialog
                        open={this.state.successDialogOpen}
                        onClose={this.handleCloseDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">הוספת עסק</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                העסק התווסף בהצלחה
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseDialog.bind(this, this.state.bid)} variant="contained"
                                    color="primary">
                                פתח את דף העסק
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </Direction>
        );
    }
}